export enum Locale {
  fr = 'fr',
}
